module.exports = __webpack_public_path__ + "static/scarlett-ffcea0d922ac0b7e8f2d8c8dc41e0cc5.jpg";